import Home from "./components/home_page/Home";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import SingleItemDetails from "./components/single_item_page/SingleItemDetails";
import ScrollToTop from "./components/general/ScrollToTop";

const SingleItemWrapper = () => {
  const location = useLocation();
  return <SingleItemDetails key={location.pathname} />;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/singleItem/:collectionId/:productId"
          element={<SingleItemWrapper />}
        />
      </Routes>
    </Router>
  );
}

export default App;
